import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { WhitelabelService } from '@galaxy/partner';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InterestOrigin } from '../enum';
import { CommonModule } from '@angular/common';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { MatRadioModule } from '@angular/material/radio';
@Component({
  selector: 'automata-automations-interest-origin-selector',
  templateUrl: './interest-origin-selector.component.html',
  styleUrls: ['./interest-origin-selector.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    GalaxyPipesModule,
    MatRadioModule,
  ],
})
export class InterestOriginSelectorComponent implements OnInit {
  readonly USER_ORIGIN = InterestOrigin.INTEREST_ORIGIN_VBC_USER;
  readonly EMAIL_ORIGIN = InterestOrigin.INTEREST_ORIGIN_EMAIL;
  readonly interestOriginControl = new UntypedFormControl(this.USER_ORIGIN, Validators.required);

  whitelabelBusinessCenterName$: Observable<string>;

  @Input() partnerId: string;
  @Input() marketId: string;
  @Output() interestOriginSelection = new EventEmitter<string>();

  constructor(
    private whiteLabelService: WhitelabelService,
    protected readonly translateService: TranslateService,
  ) {
    this.interestOriginControl.valueChanges.subscribe((v) => this.interestOriginSelection.emit(v));
  }

  ngOnInit(): void {
    this.whitelabelBusinessCenterName$ = !this.marketId
      ? this.translateService.stream('COMMON.BUSINESS_APP')
      : this.whiteLabelService.getBranding(this.partnerId, this.marketId).pipe(
          map((branding) => {
            return branding.apps.VBC.name;
          }),
        );
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.interestOriginControl];
  }

  isFormValid(): boolean {
    return this.interestOriginControl.valid;
  }

  setOrigin(origin: InterestOrigin): void {
    this.interestOriginControl.setValue(origin);
  }
}
